'use client';

import { useEffect } from 'react';
import KontentSmartLink from '@kontent-ai/smart-link';

export const KontentSmartLinks = () => {
  useEffect(() => {
    const kontentSmartLink = KontentSmartLink.initialize({
      defaultDataAttributes: {
        environmentId: process.env.NEXT_PUBLIC_KONTENT_ENVIRONMENT_ID,
        languageCodename: 'default',
      },
    });

    return () => kontentSmartLink.destroy();
  }, []);

  return null;
};
